var _rect, _rect2, _mask, _path, _path2, _path3, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIconLightGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1842,
    y: 0.5,
    width: 45.3158,
    height: 43,
    rx: 3.5,
    fill: "#F2F3F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1842,
    y: 0.5,
    width: 45.3158,
    height: 43,
    rx: 3.5,
    stroke: "#D0D3E2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5531_6472",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5182 16.5H33.0261V31.0001C33.0261 32.1047 32.1307 33.0001 31.0261 33.0001H16.5182C15.4136 33.0001 14.5182 32.1047 14.5182 31.0001V16.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5182 16.5H33.0261V31.0001C33.0261 32.1047 32.1307 33.0001 31.0261 33.0001H16.5182C15.4136 33.0001 14.5182 32.1047 14.5182 31.0001V16.5Z",
    fill: "#D0D3E2",
    stroke: "#D0D3E2",
    strokeWidth: 8,
    mask: "url(#path-2-inside-1_5531_6472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8421 12.375H34.8421V15.125H12.8421V12.375Z",
    fill: "#D0D3E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4968 11.4783C18.6784 11.1812 19.0016 11 19.3499 11H28.1944C28.5427 11 28.8659 11.1812 29.0475 11.4783L30.2499 13.4444H17.2944L18.4968 11.4783Z",
    fill: "#D0D3E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.3797,
    height: 3.0958,
    transform: "matrix(0.708752 -0.705458 0.718986 0.695024 18.3421 28.041)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.3754,
    height: 3.09689,
    transform: "matrix(-0.695805 -0.718231 0.731492 -0.68185 27.0154 30.25)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconLightGray);
export default __webpack_public_path__ + "static/media/trashIconLightGray.1e94c8085f42802acaa52a135973c277.svg";
export { ForwardRef as ReactComponent };